import { Response } from "services/types";
import { Contact, Customer, DesignThumbnail, ShopworksDesignDetails } from "./types";
import { OrderType } from "services/order/types";

export class CustomerService {
  async getCustomers(): Promise<Response<Customer[]>> {
    const token = localStorage.getItem('token') ?? '';
    const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/customers` ?? '', {
      method: "GET",
      headers: {
        'Access-Control-Allow-Origin': '*',
        "Authorization": `Bearer ${token}`
      }
    });
    const getCustomersResponse: Response<Customer[]> = await response.json();

    return getCustomersResponse;
  }

  async getCustomerById(id: number): Promise<Response<Customer>> {
    const token = localStorage.getItem('token') ?? '';
    const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/customers?id=${id}` ?? '', {
      method: "GET",
      headers: {
        'Access-Control-Allow-Origin': '*',
        "Authorization": `Bearer ${token}`
      }
    });

    const getCustomerResponse: Response<Customer> = await response.json();

    return getCustomerResponse;
  }

  async getContacts(customerId: number): Promise<Response<Contact[]>> {
    const token = localStorage.getItem('token') ?? '';
    const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/customers/contacts?customerId=${customerId}` ?? '', {
      method: "GET",
      headers: {
        'Access-Control-Allow-Origin': '*',
        "Authorization": `Bearer ${token}`
      }
    });
    const getContactsResponse: Response<Contact[]> = await response.json();

    return getContactsResponse;
  }

  async getContactById(id: number): Promise<Response<Contact>> {
    const token = localStorage.getItem('token') ?? '';
    const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/customers/contact?id=${id}` ?? '', {
      method: "GET",
      headers: {
        'Access-Control-Allow-Origin': '*',
        "Authorization": `Bearer ${token}`
      }
    });

    const getContactResponse: Response<Contact> = await response.json();

    return getContactResponse;
  }

  async getDesigns(id?: number, orderType?: OrderType): Promise<Response<DesignThumbnail[]>> {
    const token = localStorage.getItem('token') ?? '';
    const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/customers/designs?orderType=${orderType}${id ? `&customerId=${id}` : ''}` ?? '', {
      method: "GET",
      headers: {
        'Access-Control-Allow-Origin': '*',
        "Authorization": `Bearer ${token}`
      }
    });
    const getCustomersResponse: Response<DesignThumbnail[]> = await response.json();

    return getCustomersResponse;
  }

  async getDesignById(id?: number): Promise<Response<DesignThumbnail>> {
    const token = localStorage.getItem('token') ?? '';
    const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/customers/design?id=${id}` ?? '', {
      method: "GET",
      headers: {
        'Access-Control-Allow-Origin': '*',
        "Authorization": `Bearer ${token}`
      }
    });

    const getCustomerResponse: Response<DesignThumbnail> = await response.json();

    return getCustomerResponse;
  }

  async getDesignDetailsById(id?: number): Promise<Response<ShopworksDesignDetails>> {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/daubys_designs/details?id=${id}` ?? '', {
      method: "GET",
      headers: {
        'Access-Control-Allow-Origin': '*',
      }
    });

    const getDesignDetailsByIdResponse: Response<ShopworksDesignDetails> = await response.json();

    return getDesignDetailsByIdResponse;
  }

  async getLogoLocations(): Promise<Response<string[]>> {
    const token = localStorage.getItem('token') ?? '';
    const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/customers/designs/locations`, {
      method: "GET",
      headers: {
        'Access-Control-Allow-Origin': '*',
        "Authorization": `Bearer ${token}`
      }
    });

    const getLogoLocationsResponse: Response<string[]> = await response.json();

    return getLogoLocationsResponse;
  }
}

const customerService = new CustomerService();

export default customerService;
